module.exports = __webpack_public_path__ + "static/media/Trash_Can_Icon_Blue.cb613c8c.svg";